import { z, ZodType } from 'zod';

import { SignUpFormData } from '@/components/shared/Modal/content/sign-up/ModalSignUpContent.tsx';
import { formatNumber } from '@/utils';

const requiredError = 'Это обязательное поле';
const minError = 'Минимальное количество символов - 2';

export const SignUpSchema: ZodType<Omit<SignUpFormData, 'trackingParams'>> = z.object({
    msisdn: z
        .string()
        .min(1, requiredError)
        .refine(val => String(formatNumber(val)).length === 10, ''),
    firstname: z.string().min(1, requiredError).min(2, minError),
    lastname: z.string().min(1, requiredError).min(2, minError),
    agreement: z.boolean().refine(val => val),
});
